import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { deepSort } from "@utils/deepSort";
import { getCurrentUser } from "../services/currentUser";
import { IApiUser, IUserRelationships } from "../services/users";

interface IUseCurrentUserOptions {
  includes?: (keyof IUserRelationships)[];
  fields?: (keyof IApiUser)[];
  required?: boolean;
}

export const useCurrentUser = (options?: IUseCurrentUserOptions) => {
  const sortedOptions = deepSort(options);

  const {
    status,
    isLoading,
    isSuccess,
    data: currentUser,
  } = useDataQuery(
    ["currentUser", sortedOptions],
    async () => {
      try {
        const response = await getCurrentUser(options);
        return response.data;
      } catch (error) {
        throw error;
      }
    },
    {
      retry: 2,
      staleTime: 60 * 5000,
    }
  );

  return { currentUser, status, isLoading, isSuccess };
};
